import { SiteContext } from '@gn-audio/core/common/enums/site-context.enum';
import { IProductApiConfig } from '@/Foundation/ProductApi/platform/Scripts/models';

/**
 * Sets necessary attributes for document element
 * @param source Source of data to set attributes from
 */
export const setContextAttributes = (source: IProductApiConfig) => {
  setContextDataAttributes(source);
  setContextCssClasses(source);

  // Sets market locale as 'lang' attribute
  if (!document.documentElement.getAttribute('lang')) {
    document.documentElement.setAttribute('lang', getLangValue(source.language));
  }
};

/**
 * Sets necessary data attributes for document element
 * @param source Source of data to set data attributes from
 */
const setContextDataAttributes = ({ language, siteContext }: IProductApiConfig) => {
  const { dataset } = document.documentElement;

  // Sets market locale as data attribute
  const documentDataMarketLocale: string | undefined = dataset.marketLocale;
  if (!documentDataMarketLocale) {
    dataset.marketLocale = language;
  }

  // Sets site context as data attribute
  const documentDataSiteContext: SiteContext | undefined = dataset.siteContext as SiteContext;
  if (!documentDataSiteContext) {
    dataset.siteContext = siteContext;
  }
};

/**
 * Sets necessary CSS classes for document element
 * @param source Source of data to set CSS classes from
 */
const setContextCssClasses = ({ language, siteContext }: IProductApiConfig) => {
  document.documentElement.classList.add(siteContext);
  document.documentElement.classList.add(getLangValue(language));
};

const getLangValue = (language: string): string => {
  return language === 'en-us' ? 'en' : language;
};
